import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class StylesheetGroupsService {
  private url = 'stylesheet_groups';
  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  delete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }

  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }

  update(params: any = {}): Promise<any> {
    return this.httpClient.put(`${this.url}/${params.id}.json`, params);
  }

  searchOptions(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
}
